import axios from "../api/axios";
import { AuthType } from "../type/auth.types";
import { RefreshTokensResponse } from "../type/refresh-token-response.types";
import useAuth from "./useAuth";

function useRefreshToken() {
  const { auth, setAuth } = useAuth();

  return async () => {
    try {
      const response = await axios.post("/web/auth/refresh", null, {
        withCredentials: true,
      });
      const resData: RefreshTokensResponse = response.data;

      const {
        id,
        type,
        role,
        user,
        accessToken,
        onboardingStatus,
        onboardingReferenceNumber,
      } = resData;

      const newAuth: AuthType = {
        ...auth,
        id: id,
        type: type,
        role: role,
        username: user.username,
        email: user.email,
        accessToken: accessToken,
        onboardingStatus: onboardingStatus,
        onboardingReferenceNumber: onboardingReferenceNumber,
      };
      setAuth(newAuth);
      return accessToken;
    } catch (err) {}
  };
}

export default useRefreshToken;
